import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header';
import { AccountService } from './core/services/account-service';
import { SnackbarService } from './core/services/snackbar-service';
import { environment } from '../environments/environment.staging';
import { MaintenanceRequestService } from './core/services/maintenance-request-service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  title = 'Maintenance Management';
  isProduction = environment.production;
  maintenanceRequestService = inject(MaintenanceRequestService);
  msalService = inject(MsalService);
  accountService = inject(AccountService);
  snackbar = inject(SnackbarService);
  isLoading = true;

  ngOnInit(): void {
    document.title = this.title + (this.isProduction ? '' : ' - Development');

    this.msalService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (!result?.account) {
          return;
        }

        this.msalService.instance.setActiveAccount(result.account);
        this.accountService.exchangeMicrosoftToken(result.idToken).subscribe({
          error: (error) => {
            console.error('Microsoft token exchange failed:', error);
            this.snackbar.error('Microsoft sign-in could not be completed.');
          },
        });
      },
      error: (error) => {
        console.error('Microsoft sign-in redirect failed:', error);
        this.snackbar.error('Microsoft sign-in could not be completed.');
      },
    });
  }
}
